import { useState } from 'react';
import some from 'lodash/some';

export function useHTML5FormValidation({
  defaultValues = {},
  submitCallback,
} = {}) {
  const [values, setValues] = useState(defaultValues);
  const [errors, setErrors] = useState({});

  const handleChange = event => {
    if (event.persist) event.persist();

    setValues(values => ({
      ...values,
      [event.target.name]: event.target.value,
    }));

    setErrors(errors => ({
      ...errors,
      [event.target.name]: event.target.validationMessage,
    }));
  };

  const handleSubmit = event => {
    if (event) event.preventDefault();

    if (some(errors)) return;

    if (submitCallback) submitCallback(values);
  };

  return {
    errors,
    handleChange,
    handleSubmit,
    values,
  };
}
